import React, { useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  Navbar,
  Nav,
} from "react-bootstrap";
import HilltopAdZone from "./HilltopAdZone";

function Home() {
  const [images, setImages] = useState([]);
  const [convertedImages, setConvertedImages] = useState({});
  const [format, setFormat] = useState("png");
  const fileInputRef = useRef();

  // ✅ Handle file select & drag-drop (multiple)
  const handleFiles = (fileList) => {
    const validImages = Array.from(fileList).filter((f) =>
      f.type.startsWith("image/")
    );
    if (validImages.length === 0) {
      alert("Please upload valid image files!");
      return;
    }

    const newImages = validImages.map((file) => ({
      file,
      url: URL.createObjectURL(file),
      name: file.name,
    }));

    setImages((prev) => [...prev, ...newImages]);
  };

  const handleImageUpload = (e) => handleFiles(e.target.files);

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => e.preventDefault();

  // ✅ Convert single image
  const convertSingleImage = (imgObj) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imgObj.url;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const mimeType = `image/${format}`;
      const dataUrl = canvas.toDataURL(mimeType);

      setConvertedImages((prev) => ({
        ...prev,
        [imgObj.name]: dataUrl,
      }));
    };
  };

  // ✅ Download converted image
  const downloadImage = (imgName) => {
    const dataUrl = convertedImages[imgName];
    if (!dataUrl) return;
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = `${imgName.split(".")[0]}.${format}`;
    a.click();
  };

  return (
    <>
      {/* Navbar */}
      <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
        <Container>
          <Navbar.Brand href="#">Image Convert</Navbar.Brand>
          {/* <Nav className="ms-auto">
            <Nav.Link href="#">Home</Nav.Link>
            <Nav.Link href="#">About</Nav.Link>
            <Nav.Link href="#">Contact</Nav.Link>
          </Nav> */}
        </Container>
      </Navbar>

      <Container fluid className="py-5">
        <Row className="justify-content-center">
          {/* Left Vertical Ad */}
          <Col lg={2} md={3} className="d-none d-md-block">
           <HilltopAdZone zoneSrc="//tatteredpassenger.com/bUXAVcs.dfG_lG0aYdW/ce/geYm/9IuOZNU/llktPhTqYZ2iOADDkM0/Nzj/cytpNRjuY/4FOmT/QZ2jOnAC" />
            {/* <div className="ad-vertical text-center">
               <HilltopAdZone />
            </div> */}
          </Col>

          {/* Main Content */}
          <Col lg={8} md={9}>
            {/* Top Ad */}
            <Row className="justify-content-center mb-4">
              <Col md={10}>
                <div className="ad-space text-center">
                  <p>Google Ad Space (728x90)</p>
                </div>
              </Col>
            </Row>

            {/* Upload Section */}
            <Row className="justify-content-center mb-5">
              <Col md={8}>
                <Card className="p-4 shadow-lg border-0">
                  <h4 className="text-center mb-4">
                    Convert Your Images Format
                  </h4>

                  {/* Drag & Drop Zone */}
                  <div
                    className="drag-area mb-3 text-center p-4 border border-2 border-secondary rounded"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onClick={() => fileInputRef.current.click()}
                    style={{ cursor: "pointer", backgroundColor: "#f8f9fa" }}
                  >
                    <p className="text-muted mb-0">
                      Drag & Drop multiple images here or{" "}
                      <span className="text-primary">click to browse</span>
                    </p>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleImageUpload}
                      ref={fileInputRef}
                      hidden
                    />
                  </div>

                  <Form.Group className="mb-3">
                    <Form.Label>Select Output Format</Form.Label>
                    <Form.Select
                      value={format}
                      onChange={(e) => setFormat(e.target.value)}
                    >
                      <option value="jpg">JPG</option>
                      <option value="jpeg">JPEG</option>
                      <option value="png">PNG</option>
                      <option value="gif">GIF</option>
                      <option value="webp">WEBP</option>
                      <option value="avif">AVIF</option>
                      <option value="bmp">BMP</option>
                      <option value="svg">SVG</option>
                      <option value="ico">ICO</option>
                      <option value="apng">APNG</option>
                      <option value="heif">HEIF</option>
                      <option value="heic">HEIC</option>
                      <option value="jxl">JXL</option>
                    </Form.Select>
                  </Form.Group>
                </Card>
              </Col>
            </Row>

            {/* Middle Ad */}
            {/* <Row className="justify-content-center mb-4">
              <Col md={8}> */}
               {/* <HilltopAdZone zoneSrc="//tatteredpassenger.com/b/X.VHsCd_GElP0uYgWFcL/beRmX9nutZtUslQkIP/T/Y/2/OtTYIb2cNGTfkrtRNvjYYb5BM/jXYE2AMlAe" /> */}
                {/* <div className="ad-space text-center">
                  <p>Google Ad Space (728x90)</p>
                </div> */}
              {/* </Col>
            </Row> */}

            {/* Image Preview Grid */}
            <Row className="gy-4 justify-content-center">
              {images.map((imgObj, index) => (
                <Col md={5} key={index}>
                  <Card className="p-3 text-center shadow-sm">
                    <h6>{imgObj.name}</h6>
                    <img
                      src={imgObj.url}
                      alt={imgObj.name}
                      className="img-fluid rounded mb-3"
                    />
                    <div className="d-grid gap-2">
                      <Button
                        variant="primary"
                        onClick={() => convertSingleImage(imgObj)}
                      >
                        Convert to {format.toUpperCase()}
                      </Button>

                      {convertedImages[imgObj.name] && (
                        <Button
                          variant="success"
                          onClick={() => downloadImage(imgObj.name)}
                        >
                          Download Converted
                        </Button>
                      )}
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Bottom Ad */}
            {/* <Row className="justify-content-center mt-5">
              <Col md={10}> */}
              {/* <HilltopAdZone zoneSrc="//euphoricreplacement.com/b/3dVJ0-P.3mp/vNbYm/VNJTZWDC0K2zNjjRkoyGN/jqYj1lLQTqY/2AOdTII/2aNijtYU"/> */}
                {/* <div className="ad-space text-center">
                  <p>Google Ad Space (970x250)</p>
                </div> */}
              {/* </Col>
            </Row> */}
          </Col>

          {/* Right Vertical Ad */}
          <Col lg={2} md={3} className="d-none d-md-block">
          <HilltopAdZone zoneSrc="//tatteredpassenger.com/bGXGV/s.dnG/li0rY/WPcc/LeZmA9OuAZ_UDlEkzP/T/Y/2EOKTWI/2/NyTDUstYNFjuYe5mMKjrYK1XNygt" />
            {/* <div className="ad-vertical text-center">
              <p>Vertical Ad Space (300x600)</p>
            </div> */}
          </Col>
        </Row>
      </Container>

      {/* Footer */}
      <footer className="bg-dark text-light text-center py-3 mt-5">
        <p className="mb-0">
          © {new Date().getFullYear()} Easyimgconvert
        </p>
      </footer>
    </>
  );
}

export default Home;
